import { createStore } from 'vuex';
/* 状态管理  左侧导航开关   用户信息保存 */
const store = createStore({
    state() {
        return {
            institutionList: sessionStorage.getItem("institutionList") ? JSON.parse(sessionStorage.getItem("institutionList")) : [],
            reviewStatusList: [
                { deptId: '0', deptName: '待审核' },
                { deptId: '1', deptName: '审核同意' },
                { deptId: '-1', deptName: '审核拒绝' },
            ],
            // inforTypeList:sessionStorage.getItem("inforTypeList") ? JSON.parse(sessionStorage.getItem("inforTypeList")) : [],
            inforTypeList: sessionStorage.getItem("inforTypeList") ? JSON.parse(sessionStorage.getItem("inforTypeList")) : [],
            platFormSourceList: sessionStorage.getItem("platFormSourceList") ? JSON.parse(sessionStorage.getItem("platFormSourceList")) : [],
            areaInfoList: sessionStorage.getItem("areaInfoList") ? JSON.parse(sessionStorage.getItem("areaInfoList")) : [],
            deptAreaList: sessionStorage.getItem("deptAreaList") ? JSON.parse(sessionStorage.getItem("deptAreaList")) : [],
            allAuditor: sessionStorage.getItem("allAuditor") ? JSON.parse(sessionStorage.getItem("allAuditor")) : [],
        }
    },
});
export default store